module.exports = __webpack_public_path__ + "static/media/python_logo.ebec3301.png";